<template>
  <div class="comment">
    <div class="table-responsive">
      <table class="table">
        <tbody>
        <tr>
          <td class="b0 pl-0">
            <p class="h4 mt-0">
              <span class="text-bold text-info">{{ tender.approver_name }} {{ $t('tenderview.decided') }}:</span>
            </p>
            <div class="text-muted">
              {{ tender.approver_comment_content }}
              <br>{{ tender.approved | formatDate }}
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tender: Object
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Comment.vue